import { useState, useEffect, useCallback } from 'react';
import useFetchWithMsal from '../../useFetchWithMsal';
import { protectedResources } from '../../../authConfig';

const IMPORTANT_LEVELS = ['ERROR', 'WARNING', 'SUCCESS'];

const useInvoiceActivityLog = (invoice) => {
    const [activities, setActivities] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const { execute } = useFetchWithMsal({
        scopes: protectedResources.apiScopes.scopes.read,
    });

    const fetchLogs = useCallback(async () => {
        const invoiceId = invoice?.id || invoice?._id;
        if (!invoiceId) return;

        setIsLoading(true);
        setError(null);

        try {
            const response = await execute(
                'GET',
                `${process.env.REACT_APP_BACKEND_BASE_URL}/api/invoice-activity-logs/by-invoice/${invoiceId}`
            );

            const allActivities = response?.activities || [];
            const importantActivities = allActivities.filter(
                (a) => IMPORTANT_LEVELS.includes(a.level)
            );

            setActivities(importantActivities);
        } catch (err) {
            setError('שגיאה בטעינת יומן הפעילות');
        } finally {
            setIsLoading(false);
        }
    }, [invoice?.id, invoice?._id]);

    useEffect(() => {
        fetchLogs();
    }, [fetchLogs]);

    return { activities, isLoading, error, refetch: fetchLogs };
};

export default useInvoiceActivityLog;
